import classNames from 'classnames';
import React from 'react';
import SemanticHeader from '../Chapter/semantic-header';

const Shortcuts = (props) => {
  if (!props.LinkContent || props.LinkContent.length === 0) return null;

  return (
    <div className="c-shortcuts" data-cy="ui-shortcuts">
      {props.Heading && (
        <SemanticHeader
          isH3={!!props?.isH3}
          className={classNames({
            'c-shortcuts__heading': true,
            'c-shortcuts__heading--chapter-container':
              props?.isMemberOfChapterContainer,
            'c-shortcuts__heading--isH3': props?.isH3,
          })}
        >
          {props.Heading}
        </SemanticHeader>
      )}
      <ul className="c-shortcuts__list">
        {props.LinkContent.map((item, index) => {
          return (
            <li key={`compliment${index}`} className="c-shortcuts__list__item">
              <a href={item.Link}>
                <span className="c-shortcuts__list__item__container">
                  {item.ImageUrl && (
                    <span
                      className="c-shortcuts__list__item__container__img"
                      style={{
                        backgroundImage: `url(${
                          item.ImageUrl + '?preset=preset_300'
                        })`,
                      }}
                    ></span>
                  )}
                  <span className="c-shortcuts__list__item__container__text">
                    <span className="c-shortcuts__list__item__container__title">
                      {item.Heading}
                    </span>
                    {item.Description && (
                      <span className="c-shortcuts__list__item__container__description">
                        {item.Description}
                      </span>
                    )}
                  </span>
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Shortcuts;
